import { Textarea, TextAreaProps } from '@heroui/react';
import { ReactNode, forwardRef } from 'react';

interface CustomTextAreaProps extends TextAreaProps {
  label: string;
  placeholder?: string;
  variant?: 'flat' | 'faded' | 'bordered' | 'underlined';
  labelPlacement?: 'inside' | 'outside' | 'outside-left';
  minRows?: number;
  maxRows?: number;
  errorMessage?: string;
  description?: string;
  defaultValue?: string;
  isClearable?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  endContent?: ReactNode;
  startContent?: ReactNode;
  onValueChange?: (value: string) => void;
  value?: string;
}

const CustomTextArea = forwardRef<HTMLTextAreaElement, CustomTextAreaProps>(
  (
    {
      label = 'Enter label',
      placeholder = 'Enter placeholder',
      variant = 'bordered',
      labelPlacement = 'outside',
      description = '',
      errorMessage = '',
      minRows = 4,
      maxRows = 4,
      isClearable = false,
      isDisabled = false,
      isInvalid = false,
      defaultValue = '',
      startContent,
      endContent,
      onValueChange,
      value,
      ...props
    },
    ref
  ) => {
    return (
      <Textarea
        ref={ref}
        label={label}
        placeholder={placeholder}
        variant={variant}
        defaultValue={defaultValue}
        minRows={minRows}
        maxRows={maxRows}
        labelPlacement={labelPlacement}
        isDisabled={isDisabled}
        description={description}
        errorMessage={errorMessage}
        isClearable={isClearable}
        isInvalid={isInvalid}
        value={value}
        onValueChange={onValueChange}
        startContent={startContent}
        endContent={endContent}
        classNames={{
          inputWrapper:
            'bg-white border-1 border-gray-200 hover:bg-gray-50 text-xs',
        }}
        {...props}
      />
    );
  }
);

CustomTextArea.displayName = 'CustomTextArea';

export default CustomTextArea;
